import auth from './auth'
import user from './user'
import operations from './operations'
import setAuthorizationHeader from "./setAuthorizationHeader"
import media_object from "./mediaObject"
import participation from "./participation"

export default {
  auth,
  user,
  operations,
  media_object,
  participation,
  setAuthorizationHeader
}



// WEBPACK FOOTER //
// ./src/api/index.js